import apiWrapper from '../../services/apiWrapper';

export const fetchChurches = async () => {
  try {
    const response = await apiWrapper('get', '/admin/churches');
    return response;
  } catch (error) {
    console.error('Error fetching churches:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while fetching churches. Please try again later.'
    };
  }
};

export const backupChurches = async () => {
  try {
    const response = await apiWrapper('get', '/admin/backup-churches', null, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response;
  } catch (error) {
    console.error('Error backing up churches:', error);
    throw error;
  }
};

export const restoreChurches = async (formData) => {
  try {
    const response = await apiWrapper('post', '/admin/restore-churches', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    console.error('Error restoring churches:', error);
    throw error;
  }
};